<template>
  <div class="general-page">
    <template v-if="!sent">
      <h1>Forgotten Password</h1>

      <p>Provide your email address and we will email you reset instructions.</p>
      <div class="qform2022 full">
        <p
          v-if="first(errors) || errors.recaptcha_response"
          class="notice error live"
        >
          <span class="icon-attention redicon" />
          {{ first(errors) }}
        </p>

        <form
          class="reminder-form"
          @submit.prevent="post"
        >
          <div class="generic-inputs">
            <label>Email Address*</label>
            <input
              v-model="email"
              dusk="email"
              type="text"
              placeholder="Email Address"
              name="email"
            >
          </div>

          <div v-if="recaptchaFields.required">
            <vue-recaptcha
              ref="recaptcha"
              :sitekey="recaptchaKey"
              @verify="recaptchaCompleted"
            />
            <br>
          </div>

          <div
            v-if="loading"
            class="twobuttons"
          >
            <img
              src="/assets/images/loading.gif"
              style="width:200px;"
            >
          </div>
          <div
            v-else
            class="twobuttons"
          >
            <button class="button reset-password">
              Reset
            </button>
            <span>or</span>
            <router-link
              v-slot="{ navigate }"
              :to="{ name: 'sms-login'}"
              custom
            >
              <button
                class="button clear"
                @click="navigate"
              >
                Login via SMS instead
              </button>
            </router-link>
          </div>
        </form>
      </div>
      <br>
      <p class="last">
        <a
          href="/portal"
          class="normal-link"
        >Create an account</a> if you don't have one or <router-link :to="{ name: 'login'}">
          login
        </router-link>.
      </p>
    </template>
    <template v-else>
      <h1 class="email-sent">
        Email Sent
      </h1>

      <p>We've sent an email to {{ email }} with a secure link that you can use to reset your password.</p>

      <p>Please check your email account including your spam folder.</p>
    </template>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import authComposable from "./AuthComposable.js";
import axios from '../../axios.js'
import {VueRecaptcha} from "vue-recaptcha";
import { useRoute } from 'vue-router';

export default {
    components: {
        VueRecaptcha
    },
    setup() {
        const route = useRoute();
        const loading = ref(false);
        const email = ref(null);
        const sent = ref(false);
        const errors = ref([]);
        const { recaptchaFields, resetCaptcha, recaptchaKey, first, recaptchaCompleted } = authComposable();

        const post = () => {
            loading.value = true;
            errors.value = [];

            let data = {
                email: email.value,
                recaptcha_response: recaptchaFields.response,
            };

            axios({
                method: 'post',
                url: `/auth/forgotten-password`,
                data: data
            }).then(response => {
                if (!response.data.success) {
                    errors.value = response.data.errors;

                    if(errors.value.recaptcha_response) {
                        recaptchaFields.required = true;
                    }
                } else {
                    sent.value = true;
                }
                loading.value = false;
            }).catch(() => {
                errors.value = {general: ['Something went wrong; please try again later.']};
                loading.value = false;
            }).then(() => {
                resetCaptcha();
            });
        };

        const loadRecaptcha = () => {
            axios({
                method: 'get',
                url: `/auth/password/captcha`,
            }).then(response => {
                if (response.data.captcha) {
                    recaptchaFields.required = true;
                } else {
                    recaptchaFields.required = false;
                }
            }).catch(error => {
                console.log(error);
                recaptchaFields.required = false;
            });
        };

        onMounted(() => {
            if (route.query.email) {
                email.value = route.query.email;
            }
            loadRecaptcha();
        });

        return {
            loading,
            email,
            sent,
            errors,
            post,
            recaptchaKey,
            recaptchaFields,
            loadRecaptcha,
            first,
            recaptchaCompleted
        };
    },
};
</script>
